import { render, staticRenderFns } from "./DanhGiaForm.vue?vue&type=template&id=0e356a3b"
import script from "./DanhGiaForm.vue?vue&type=script&lang=js"
export * from "./DanhGiaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports